const staff = {
  Ari: {
    name: 'Ariana Murray Wells',
    title: 'Product Designer',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMTQ4NjI5NTA2NTc5MDIwNTIyNjY=',
    pictureUrl:
      'https://lh4.googleusercontent.com/-9YjOahnbF08/AAAAAAAAAAI/AAAAAAAAABQ/qj-Vwz_26oQ/photo.jpg',
  },
  AlexR: {
    name: 'Alex Rose',
    title: 'Co-founder',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMTQyNjU4MTg1MjgyMjg1ODg0ODA=',
    pictureUrl:
      'https://lh5.googleusercontent.com/-lGXY7sDzyjA/AAAAAAAAAAI/AAAAAAAAAA8/ElBhuc1z4d8/photo.jpg',
  },
  JohnK: {
    name: 'John Kent',
    title: 'Key Account Manager',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMDYxMzYyOTExOTY5MDEwNjM1Mzk=',
    pictureUrl:
      'https://lh4.googleusercontent.com/-7dGem_Mmfo8/AAAAAAAAAAI/AAAAAAAAAAA/bKp0bKwnBjY/photo.jpg',
  },
  Marc: {
    name: 'Marc Hibbins',
    title: 'Senior Developer',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMDg1NjU3MDUwMDI3MjMxMDU4MDA=',
    pictureUrl:
      'https://lh5.googleusercontent.com/-5W64z6uAucs/AAAAAAAAAAI/AAAAAAAAAAc/zCqHp0AYfAg/photo.jpg',
  },
  Neil: {
    name: 'Neil Lock',
    title: 'Co-founder',
    permalink: '/profile/ZmFjZWJvb2t8MTAxMDA4NTczODAxNjI5NDI=',
    pictureUrl:
      'https://scontent.xx.fbcdn.net/v/t1.0-1/p50x50/26230542_10101273827953232_4456657922075860085_n.jpg?oh=6e94a6d435138f64d2721ebdeff577ee&oe=5B4CB01A',
  },
  Olly: {
    name: 'Olly Freeman',
    title: 'Senior Developer',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMTYyODIwMjYyNzQzODU4OTUwNzQ=',
    pictureUrl:
      'https://lh3.googleusercontent.com/-gPQQ8G6eBPg/AAAAAAAAAAI/AAAAAAAAAB0/mLkpZh0hYqo/photo.jpg',
  },
  Sam: {
    name: 'Sam Browne',
    title: 'Co-founder',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMTIyNjAzMzAyNzkwMzE0MDc4MTA=',
    pictureUrl:
      'https://lh5.googleusercontent.com/-ZwiqsixZGc0/AAAAAAAAAAI/AAAAAAAAAU4/IELWWJl0F4s/photo.jpg',
  },
  Stan: {
    name: 'Constantine Louloudis',
    title: 'Head of Partnerships',
    permalink: '/profile/Z29vZ2xlLW9hdXRoMnwxMTIzOTYyMzI5NTc3MTkyMTc1Mzg=',
    pictureUrl:
      'https://d178fu9mi2dmkb.cloudfront.net/uploads/2018/03/11194833/Headshot1.png',
  },
};

export default staff;



// WEBPACK FOOTER //
// ./app/src/state/staff.js